'use strict';

import Swiper from 'swiper';

const SELECTOR = '.js-scroller';

export function initialiseElement(element) {
    const scrollerElement = element.querySelector('.swiper-container');

    const mq = window.matchMedia('(max-width: 928px)');

    let scroller;

    const settings = {
        slidesPerView: 'auto',
        freeMode: true,
        simulateTouch: false,
        mousewheel: {
            releaseOnEdges: true,
            forceToAxis: true,
            invert: true,
            sensitivity: .8
        },
        navigation: {
            nextEl: element.querySelector('.scroller-next'),
            prevEl: element.querySelector('.scroller-prev')
        },
        observer: true
    };

    if (!mq.matches) {
        scroller = new Swiper( scrollerElement, settings );
    }

    function loadScroller(event) {
        if (event.matches) {
            scroller.destroy( true, true );
        } else {
            scroller = new Swiper( scrollerElement, settings );
        }
    }

    mq.addListener(loadScroller);

}

export function init() {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}

export default {
    init,
    initialiseElement
}
